export const ROOM_META_DATA = {
  OFFICE: "office-address",
  BUILDING: "buildings",
  ROOM_TYPE: "room-types",
  ROOM: "rooms",
  DESK: "desk",
};
